var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconBrowserPageText2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3ZM9.65 2a1 1 0 0 1 1.7 0 .91.91 0 0 1 0 1 1 1 0 0 1-1.7 0 .91.91 0 0 1 0-1m-3.5 0a1 1 0 0 1 1.7 0 .91.91 0 0 1 0 1 1 1 0 0 1-1.7 0 .91.91 0 0 1 0-1m-3.56.09A1 1 0 0 1 4.35 2a.91.91 0 0 1 0 1 1 1 0 0 1-1.7 0 1 1 0 0 1-.15-.5 1.1 1.1 0 0 1 .09-.41M3 22a1 1 0 0 1-1-1V5.25A.25.25 0 0 1 2.25 5h6a.25.25 0 0 1 .25.25v16.5a.25.25 0 0 1-.25.25Zm19-1a1 1 0 0 1-1 1H10.25a.25.25 0 0 1-.25-.25V5.25a.25.25 0 0 1 .25-.25h11.5a.25.25 0 0 1 .25.25Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 5.5,
  x: 12.5,
  y: 7,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 7.25a.76.76 0 0 0 .75.75h2a.75.75 0 0 0 0-1.5h-2a.76.76 0 0 0-.75.75M5.5 12h.75a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0 0 1.5M4.25 16h2a.75.75 0 0 0 0-1.5h-2a.75.75 0 0 0 0 1.5M5.5 20h.75a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0 0 1.5"
}), /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 5.5,
  x: 12.5,
  y: 14.5,
  rx: 1
}))));
export default SvgStreamlineIconBrowserPageText2;